<!--Generel Strategie-->

<!--Speicherprioritäten des user accounts:-->

<!--1. Firebase-->
<!--2. MongoDB-->
<!--3. vuex store-->

<template>
  <div class="page">

    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon medium dark >mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <v-container class="bgw">

      <!--            <h2>Account</h2>-->
      <div class="spacer-25"></div>

      <div class="mb-6" v-if="$store.getters.enableStempel">
        <v-btn
          color="primary" rounded medium class="btn-df"
          @click="$ebus.$emit('goto', {name:'Stempelkarte'})"
        >Zur Stempelkarte
          <v-icon medium>mdi-arrow-right</v-icon>
        </v-btn>
      </div>

      <div><h3 class="mb-5">Dein Account</h3></div>
      <!--            <div>Name: {{user.name}}</div>-->
      <!--            <div>E-Mail: {{user.email}} ({{user.emailVerified ? 'verifiziert' : 'nicht verifiziert'}})</div>-->
      <!--            <div>Mobilnummer: {{user.phone}}</div>-->
      <v-form ref="form" v-model="valid" lazy-validation class="registerForm bigger-input">
        <div>
          <label for="">Vor- und Nachname *</label>
          <v-text-field
            class="roundInput"
            v-model="formData.name"
            :rules="nameRules"
            hide-no-details illed outlined
            required
            @focus="hideToolbar"
            @blur="unhideToolbar"
          ></v-text-field>
        </div>

        <div>
          <label for="">E-Mail* (Bestelleingangsbestätigung)</label>
          <v-text-field
            class="roundInput"
            v-model="formData.email"
            type="email"
            :rules="emailRules"
            hide-no-details illed outlined
            required
            @focus="hideToolbar"
            @blur="unhideToolbar"
          ></v-text-field>
        </div>

        <div>
          <label for="">Mobilnummer</label>
          <v-text-field
            class="roundInput"
            ref="phone"
            v-model="formData.phone"
            illed outlined
            required
          ></v-text-field>
        </div>

        <div class="spacer-25"></div>
        <div class="error--text mt-2 mr-4" v-if="displayErrors.length > 0 && initialTry"
             v-html="displayErrors"></div>
        <div class="d-flex flex-wrap align-center justify-sm-start">
          <v-btn
            @click="doSubmit"
            class="btn-df mr-5 mt-2 mb-10"
            rounded
          >Übernehmen
          </v-btn>
        </div>
      </v-form>

      <div class="spacer-25"></div>
      <div><h3>Optionen</h3></div>
      <!--            <div class="mt-4">-->
      <!--                <v-btn class="btn-mini" @click.native.passive="mail('Datenänderung für '+user.email)">Daten ändern-->
      <!--                </v-btn>-->
      <!--            </div>-->
      <div style="max-width: 320px">
        <v-btn class="mt-4 btn-mini maxw"
               @click.native.passive="$ebus.$emit('goto', {name:'resetPassword'})">
          Passwort vergessen
        </v-btn>
        <v-btn class="mt-4 btn-mini maxw" @click.native.passive="logout('Logout')">Abmelden</v-btn>
        <v-btn class="mt-4 btn-mini maxw " @click.native.passive="$ebus.$emit('goto',{name:'Registrierung'})">
          Neuer Account erstellen
        </v-btn>
        <v-btn class="mt-4 btn-mini maxw"
               @click.native.passive="mail('Account löschen für '+$store.user.email)">Account
          löschen
        </v-btn>
      </div>

      <div class="spacer-25"></div>

      <!--        The sms dialog always calls either cancleDialog or verifySmsCode-->
      <sms-dialog :dialog="smsDialog"
                  @close="smsDialog = false"
                  @cancleDialog="cancleDialog"
                  @verifySmsCode="verifySms"></sms-dialog>

      <!--        <qsignal class="hide-md"></qsignal>-->

    </v-container>
  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as firebaseUtil from '../firebase/firebaseUtil'
// import * as xhr from '../api/xhr.js'
// import {action$MC_UpsertAppUser} from '../vendor/qconstants'
// import {btaste} from '../vendor/bootstrap';
import * as util from '../vendor/util'
// import {cloneMe, removeCharacter} from '../vendor/util'
import SmsDialog from "../dialogs/SmsDialog";
import {isMobileOk} from "@/vendor/util";

export default {
  components: {SmsDialog},

  data() {
    return {
      duringSave: false,

      displayErrors: '',

      nameRules: [
        v => (!v || this.isNameOk(v)) || 'Ungültiger Name',
      ],

      emailRules: [
        // v => !!v || 'E-Mail is required',
        v => (!v || (/.+@.+[.].+/.test(v))) || 'Ungültige E-Mail',
      ],

      // phoneRules: [
      //     v => !!v || 'Die Mobilnummer wird benötigt',
      //     v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
      //     v => (v.length >= 10) || 'Die Mobilnummer ist zu kurz'
      // ],

      smsDialog: false,

      valid: true,
      showForm: true,

      formData: {
        name: '',
        email: '',
        password: '',
        phone: '',//'+49',
        // techPhone: '', // with +49
        // company: '',
        invoiceAddress: {
          company: '',
          street: '',
          plz: '',
          city: '',
          // etage: '',//optional
        },
      },

      // user: util.cloneMe(store.state.user),
      currentStep: 2,
      inputNameCompleted: false,
      inputPhoneCompleted: false,

      updateFireNameOk: false,
      updateFireEmailOk: false,

      // company: '',

      // invoiceAddress: {
      //     company: '',
      //     street: '',
      //     plz: '',
      //     city: '',
      //     // etage: '',//optional
      // },

      // valid: true,
      showForm: true,
      // nameRules: [
      //     v => !!v || 'Name ist erforderlich',
      //     v => (v && v.length >= 4) || 'Name muss mindestens 4 Zeichen haben'
      // ],
      // emailRules: [
      //     v => !!v || 'E-mail ist erforderlich',
      //     v => /.+@.+[.].+/.test(v) || 'E-mail muss gültig sein'
      // ],
      // select: null,
      // items: [
      //     'Item 1',
      //     'Item 2',
      //     'Item 3',
      //     'Item 4'
      // ],
      // checkbox: false
    }
  },

  watch: {
    // company(newValue) {
    //     this.saveCompany(newValue);
    //     // this.$ls.set('company', newValue);
    // }
    // phone(newValue) {
    //         if (!newValue) {
    //             this.phone = '+43';
    //             // } else if (newValue.length > 2 && !newValue.startsWith('+49')) {
    //             //     this.phone = '+49' + newValue;
    //         }
    //     }
  },

  beforeMount() {
    if (store.getters.loggedIn === false) {
      this.$router.push({name: 'Home'});
    }
    // if (this.formData.phone < 3) {
    //     this.formData.phone = '+49';
    // }
  },

  created() {
    ebus.$on('userSignedOut', () => {
      this.$router.push({name: 'Home'});
    });

    ebus.$on('accountUpdated', () => {
      this.init();
      this.upsertOk();
      store.commit('showLoading', false);
    });

    ebus.$on('failed-upsertUserAccount', () => {
      this.upsertNotOk();
      store.commit('showLoading', false);
    });
  },

  mounted() {
    if (!store.getters.loggedIn) {
      this.$router.push({name: 'Home'});
      return;
    }
    firebaseUtil.initRecaptcha(() => {
      //captcha solved, now trigger verification
    })

    this.updateFireNameOk = false;
    this.updateFireEmailOk = false;
    this.init();

    this.preselectFields();
    // this.updateCurrentStep();
  },

  // activated() {
  //     this.updateFireNameOk = false;
  //     this.updateFireEmailOk = false;
  //     this.init();
  //
  //     this.preselectFields();
  //     // this.updateCurrentStep();
  // },
  destroyed() {
    this.unhideToolbar();

    util.clearEvents([
      'userSignedOut',
      'accountUpdated',
      'failed-upsertUserAccount',
    ]);

  },


  methods: {
    validate() {
      try {
        return this.$refs.form.validate()
      } catch (e) {
        return false;
      }
    },

    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },

    isNameOk(v) {
      name = this.formData.name;
      if (v) {
        name = v;
        // console.log('isNameOk v=' + v);
      }
      if (name && !(name.length < 4 || name.indexOf(' ') < 2 || name.endsWith(' '))) {
        let nn = this.formData.name.substring(name.indexOf(' ') + 1, name.length);
        // console.log('Nachname: ' + nn);
        // console.log('Nachname length : ' + nn.length);
        let ok = (nn.length > 1);
        // console.log('isNameOk=' + ok);
        return ok;
      }
      // console.log('isNameOk=' + false);
      return false;
    },

    mail(subject) {
      let mailto_link = 'mailto:support@qsignal.de?subject=' + subject;
      let win = window.open(mailto_link);//, '_blank');
      win.focus();
    },

    // saveCompany(c) {
    //     let fd = this.$ls.get('formData') ||{};
    //     if (!fd.invoiceAddress) {
    //         fd.invoiceAddress = {
    //             company: '',
    //             street: '',
    //             plz: '',
    //             city: '',
    //         }
    //     }
    //     fd.invoiceAddress.company = c;
    //     this.$ls.set('formData', fd);
    // },

    logout() {
      firebaseUtil.gevent('logout');
      store.commit('isLoggingOut', true);
      firebaseUtil.logout((ok) => {
        // if (ok) {
        //     this.$ebus.$emit('Logout was succesful');
        //     this.$router.push({name: 'Home'});
        // }
      });
    },

    // updateDisplayPhone(tPhone) {
    //     let p = tPhone;
    //     this.formData.phone = '0' + p.substring(3, p.length);
    // },

    preselectFields() {
      let fbUser = firebaseUtil.getUser();
      if (fbUser) {
        if (fbUser.displayName) {
          this.formData.name = fbUser.displayName;
        }
        if (fbUser.email) {
          this.formData.email = fbUser.email;
        }
        if (fbUser.phoneNumber) {
          // this.updateDisplayPhone(fbUser.phoneNumber);
          // let p = fbUser.phoneNumber;
          // this.formData.phone = '0' + p.substring(3, p.length);
        }
      }

      // let fd = this.$ls.get('formData') ||{};
      // if (fd.invoiceAddress) {
      //     let ia = fd.invoiceAddress;
      //     if (ia.company) {
      //         this.invoiceAddress.company = ia.company;
      //     }
      //     if (ia.street) {
      //         this.invoiceAddress.street = ia.street
      //     }
      //     if (ia.plz) {
      //         this.invoiceAddress.plz = ia.plz
      //     }
      //     if (ia.city) {
      //         this.invoiceAddress.city = ia.city
      //     }
      //     // if (ia.etage) {
      //     //     this.invoiceAddress.etage = ia.etage
      //     // }
      // }

      // let _company = this.$ls.get('company');
      // if (_company) {
      //     this.invoiceAddress.company = _company;
      // }
    },

    init() {

      // let u = util.cloneMe(store.state.user);
      this.formData = util.cloneMe(store.state.user);
      // this.updateDisplayPhone(u.phone)

      // let _invoiceAddress = this.$ls.get('invoiceAddress');
      // if (_invoiceAddress) {
      //     this.invoiceAddress = JSON.parse(_invoiceAddress);
      //     if (!this.invoiceAddress.company) {
      //         this.invoiceAddress.company = ''
      //     }
      //     if (!this.invoiceAddress.plz) {
      //         this.invoiceAddress.plz = ''
      //     }
      //     if (!this.invoiceAddress.etage) {
      //         this.invoiceAddress.etage = ''
      //     }
      //     if (!this.invoiceAddress.note) {
      //         this.invoiceAddress.note = ''
      //     }
      // }
    },

    saveAddress() {
      // // this.$ls.set('company', '' + this.invoiceAddress.company);
      // // util.sanitizeProps(this.invoiceAddress);
      // // this.invoiceAddress.company.trim();
      // // this.invoiceAddress.street.trim();
      // // this.invoiceAddress.plz.trim();
      // // this.invoiceAddress.city.trim();
      // // this.invoiceAddress.etage.trim();
      // ebus.$emit('localStoreIA', util.cloneMe(this.invoiceAddress));
      // // this.$ls.set('invoiceAddress', JSON.stringify(this.invoiceAddress));
      // // ebus.$emit('updateRelevantArea');
    },

    // updateCurrentStep() {
    //     let user = firebaseUtil.getUser();
    //     if (user) {
    //         let hasName = false;
    //         if (user.displayName && user.displayName.length > 2) {
    //             hasName = true;
    //             this.currentStep = 3;
    //             this.inputNameCompleted = true;
    //         }
    //
    //         if (user.phoneNumber && user.phoneNumber.length > 4) {
    //             this.inputPhoneCompleted = true;
    //             if (!hasName) {
    //                 this.currentStep = 2;
    //                 return;
    //             }
    //         }
    //         this.currentStep = 2; // name input
    //     }
    // },

    notifyError(text, err) {
      ebus.$emit('info', 'Error: ' + text + ' ' + err);
    },

    // notifyInfo(text, err) {
    //     this.$notify({
    //         type: 'info',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    cancleDialog() {
      store.commit('showLoading', false);
      this.duringSave = false;
    },

    verifySms(smsCode) {
      console.log('??? try to verifySmsCode ' + smsCode);
      let phoneCredential = firebaseUtil.verifySmsCode(smsCode);
      //update user
      firebaseUtil.getUser().updatePhoneNumber(phoneCredential).then((updatedUser) => {
        console.log('??? updatePhoneNumber succeeded');
        ebus.$emit('upsertUserAccount');
        // this.upsertAccount();
      }).catch((verifyErr) => {
        console.log('phone updateErr: ' + verifyErr);
        this.notifyError('Fehler bei der Mobilnummer', verifyErr);
        store.commit('showLoading', false);
      })
    },

    upsertOk() {
      if (this.duringSave) {
        ebus.$emit('toast', 'Speicherung erfolgreich');
        this.duringSave = false
      }
      // this.updateCurrentStep();
    },

    upsertNotOk() {
      if (!store.state.duringRegistration) {
        this.notifyError('Fehler beim Speichern');
      }
      this.duringSave = false
    },

    lazyUpdateName() {
      if (store.state.user.name !== this.formData.name) {
        console.log('Account:: name has changed to ' + this.formData.name);
        firebaseUtil.updateName(this.formData.name, (ok) => {
          console.log('Account:: Name has been updated ok=' + ok);
          this.updateFireNameOk = ok;
        });
      } else {
        this.updateFireNameOk = false;
      }
    },

    lazyUpdateEmail() {
      if (store.state.user.email !== this.formData.email) {
        firebaseUtil.updateUserEmail(this.formData.email, (okObj) => {
          console.log('??? Email update ok + ' + okObj.ok);
          this.updateFireEmailOk = okObj.ok;
          if (!this.updateFireEmailOk) {
            if (okObj.error && ('' + (okObj.error)).indexOf('requires-recent-login') !== -1) {
              ebus.$emit('showInfo', {
                title: 'Zur Durchführen der gewünschten Änderung ist eine erneute Anmeldung erforderlich'
              });
              this.$router.push({name: 'Anmelden'});
            } else {
              ebus.$emit('toast', 'Error: ' + okObj.error);
            }
          }
        });
      } else {
        this.updateFireEmailOk = false;
      }
    },

    lazyUpdatePhone() {
      if (!firebaseUtil.getPhone() || this.getTphone(this.formData.phone) !== firebaseUtil.getPhone()) {
        console.log('Phone not valid or unchanged');
        this.$nextTick(() => {
          this.startPhoneValidation();
        });
      } else {
        console.log('Phone already valid and unchanged');
      }
    },

    validateInput() {
      // //street
      // if (this.invoiceAddress.street.length > 0 && this.invoiceAddress.street.length < 4) {
      //     return 'Die Straße ist erforderlich';
      // }
      //
      // if (this.invoiceAddress.street.length > 0 && (/\d/.test(this.invoiceAddress.street) === false)) {
      //     return 'Die Hausnummer fehlt';
      // }
      //
      // //validate plz
      // let plz = util.removeSpaces(this.invoiceAddress.plz);
      // if (isPlzOk(plz) === false) {
      //     return 'Die Postleitzahl muss eine Nummer sein';
      // }
      // if (plz.length < 4) {
      //     return 'Die Postleitzahl ist zu kurz';
      // }
      //
      // //city
      // if (this.invoiceAddress.city && this.invoiceAddress.city.length < 3) {
      //     return 'Der Ort ist erforderlich';
      // }

      if (this.formData.name.length < 3) {
        return 'Der Name ist erforderlich';
      }

      if (this.formData.name.length < 4 || this.formData.name.indexOf(' ') < 2) {
        return 'Bitte Vor- und Nachname eingeben';
      } else {
        let nn = this.formData.name.substring(this.formData.name.indexOf(' ') + 1, this.formData.name.length);
        if (nn.length < 2) {
          return 'Bitte Vor- und Nachname eingeben';
        }
      }

      if (/.+@.+[.].+/.test(this.formData.email) === false) {
        return 'Die E-Mail Addresse ist ungültig';
      }

      if (!isMobileOk(this.formData.phone)) {
        return 'Die eingegebene Mobilnummer ist ungültig';
      }

      return true;
    },

    doSubmit() {
      console.log('Account:: doSubmit()...');

      this.$store.commit('showLoading', true);

      if (!this.validate()) {
        this.$store.commit('showLoading', false);
        return;
      }

      //validate input
      let validationErros = this.validateInput();
      if (validationErros.length > 0) {
        store.commit('showLoading', false);
        ebus.$emit('showInfo', {title: validationErros, text: 'Bitte korrigiere deine Eingabe'});
        return;
      }

      this.duringSave = true;

      setTimeout(() => {
        store.commit('showLoading', false);
      }, 5000);

      this.saveAddress();

      this.lazyUpdateName();
      this.lazyUpdateEmail();
      this.lazyUpdatePhone();

      setTimeout(() => {
        console.log('Account:: 2 seconds later');
        if (this.updateFireNameOk || this.updateFireEmailOk) {
          console.log('Account:: something has changed so upsertUserAccount');
          ebus.$emit('upsertUserAccount');
        } else {
          console.log('Account:: nothing has changed');
          // ebus.$emit('toast', 'Keine Änderungen');
        }
      }, 3000);

      // let tPhone = '' + this.formData.phone;
      // if (tPhone.startsWith('00')) {
      //     tPhone = '+' + tPhone.substring(2, tPhone.length);
      //     //00490176 results in +490176
      // } else if (!tPhone.startsWith('+49')) {
      //     tPhone = '+49' + tPhone;
      // }
      // // if (!this.formData.phone.startsWith('+')) {
      // //     this.formData.phone = '+' + this.formData.phone;
      // // }
      //
      // //remove all spaces
      // tPhone = tPhone.replace(/\s/g, '');
      // if (tPhone.startsWith('+') && tPhone.length >= 4 && tPhone.charAt(3) === '0') {
      //     //remove the zero after the country
      //     tPhone = util.removeCharacter(tPhone, 3);
      // }
      //
      // // this.updateDisplayPhone(tPhone);
      // // this.formData.phone = _phone;
      //
      // console.log('user phone = ' + this.formData.phone);
      // console.log('store phone = ' + store.state.user.phone);
      // if (tPhone !== store.state.user.phone) {
      //     // store.commit('showLoading', false);
      //     //User wants to add the phone number
      //     console.log('??? try to send sms...');
      //     firebaseUtil.sendSms(tPhone, (smsSent) => {
      //         console.log('??? SMS sent = ' + smsSent);
      //         if (smsSent) {
      //             this.FIXME phone error:ue;
      //         } else {
      //             this.notifyError('Mobilnummer ist ungültig!');
      //         }
      //         this.$nextTick(() => {
      //             store.commit('showLoading', false);
      //         });
      //     });
      // } else {
      //     console.log('Account:: phone number has not changed');
      //     setTimeout(() => {
      //         ebus.$emit('upsertUserAccount');
      //     }, 1200);
      // }

    },

    getTphone(phone) {
      let tPhone = '' + phone;
      if (tPhone.startsWith('00')) {
        tPhone = '+' + tPhone.substring(2, tPhone.length);
        //results in +490176
      } else if (!tPhone.startsWith('+49')) {
        tPhone = '+49' + tPhone;
      }
      // if (!this.formData.phone.startsWith('+')) {
      //     this.formData.phone = '+' + this.formData.phone;
      // }

      //remove all spaces
      tPhone = tPhone.replace(/\s/g, '');
      if (tPhone.startsWith('+') && tPhone.length >= 4 && tPhone.charAt(3) === '0') {
        //remove the zero after the country
        tPhone = util.removeCharacter(tPhone, 3);
      }
      return tPhone;
    },

    startPhoneValidation() {
      // let fbUser = firebaseUtil.getUser();
      // if (fbUser && fbUser.phoneNumber && fbUser.phoneNumber.length > 6) {
      //     //phone number already registered
      //     this.doSendSms = false;
      //     console.log('bugIsAccount phoneNumber in startPhoneValidation is already verified');
      //     this.checkAccountAndFinish();
      //     return;
      // }

      //Now add the mobile number
      let tPhone = this.getTphone(this.formData.phone);

      console.log('??? tPhone = ' + tPhone);
      this.formData.phone = tPhone;

      firebaseUtil.sendSms(tPhone, (smsSent) => {
        console.log('??? SMS sent = ' + smsSent);
        if (smsSent) {
          this.smsDialog = true;
          store.commit('showLoading', false);
        } else {
          this.handleError('Deine Mobilnummer ist ungültig!', 'Bitte überprüfe deine Mobilnummer');
        }
      });
    },

    verifySms(smsCode) {
      console.log('??? try to verifySmsCode ' + smsCode);
      let phoneCredential = firebaseUtil.verifySmsCode(smsCode);

      console.log('bugIsAccount phoneCredential: ' + phoneCredential);

      //update user
      firebaseUtil.updatePhone(phoneCredential).then((updatedUser) => {
        console.log('bugIsAccount updatePhoneNumber inside verifySms succeeded');
        ebus.$emit('toast', 'Die Mobilnummer wurde bestätig');
        // }
      }, (verifyErr) => {
        console.log('bugIsAccount phone verifyError: ' + JSON.stringify(verifyErr));
        let msg;
        if (verifyErr.code === 'auth/invalid-verification-code') {
          msg = 'Der eingegebene Bestätigungscode ist ungültig';
        } else if (verifyErr.code === 'auth/credential-already-in-use') {
          msg = 'Die Mobilnummer wird bereits von einem anderen Account verwendet';
        } else {
          msg = 'Fehler bei der Überprüfung der Mobilnummer';
        }
        //https://firebase.google.com/docs/reference/node/firebase.User.html#updatephonenumber
        this.handleRegistrationError(msg);
      });
    },

    handleError(errorMsg, errText) {
      this.$nextTick(() => {
        this.process.submitted = false;
        store.commit('showLoading', false);
        if (errText) {
          ebus.$emit('showInfo', {title: errorMsg, text: errText});
        } else {
          ebus.$emit('showInfo', {title: errorMsg});
        }
      });
    },
    // reset () {
    //     this.$refs.form.reset()
    // },
    // resetValidation () {
    //     this.$refs.form.resetValidation()
    // }
  }
}
</script>
<style lang="scss" scoped>

/*.accountForm {*/
/*    > > > .v-text-field.v-text-field--enclosed {*/
/*        padding: 4px 0;*/
/*    }*/
/*}*/

.myTable {
  tr {
    td:first-child {
      width: 115px;
    }

    td:last-child {
      padding-left: 8px;
    }
  }
}

/*.accountBeader {*/
/*    padding: 15px 16px;*/
/*    padding-top: 0;*/
/*    text-align: center;*/
/*    //background-color: $primary-color-3-b;*/
/*}*/

/*.vvd {*/
/*    > > > .v-stepper__label {*/
/*        display: block;*/
/*        text-align: center;*/
/*    }*/

/*    > > > .v-stepper__step {*/
/*        padding: 15px 4px;*/
/*        flex-basis: 120px;*/
/*    }*/
/*}*/


</style>
